import _ from 'lodash';

import { getEnvVar } from '../../utils/env';

export const alphabeticalOptionsSort = (a, b) => a.translatedText?.localeCompare(b.translatedText);

export const createFormEditorUrl = (searchParams, formKey) => {
  const urlParams = new URLSearchParams(searchParams);
  return `?entityType=${urlParams.get('entityType')}&formKey=${formKey}&itmId=${urlParams.get(
    'itmId'
  )}`;
};

export const getFormURL = (formKey, token) =>
  `${getEnvVar(
    'REACT_APP_ADMIN_APP_URL'
  )}/designer/ssformdesigner.aspx?formKey=${formKey}&Token=${token}`;

export const setDividers = (menuItems) => {
  const groupsSet = new Set();

  menuItems.forEach(({ group }) => {
    groupsSet.add(group);
  });

  if (groupsSet.size === 1) {
    return;
  }

  const designFormLastItem = _.findLast(menuItems, ({ group }) => group === 'designForm');
  designFormLastItem.divider = true;

  if (groupsSet.size === 3) {
    const editFormLastItem = _.findLast(menuItems, ({ group }) => group === 'editForm');
    editFormLastItem.divider = true;
  }

  return;
};
